import { createCtx } from '@shared/util/context';
import {
  CardPaginationQuery,
  CardPaginationQueryState,
  CardPaginationQueryStateWithCards,
} from './types';

interface State {
  stateByQuery: { [jsonStringifiedQuery: string]: CardPaginationQueryState };
  cardById: { [cardId: string]: MBAPI.Card };
}

export interface ActionsContext {
  fetchMore(
    query: CardPaginationQuery,
    reset?: boolean,
  ): Promise<CardPaginationQueryStateWithCards | undefined>;
  addCard(card: MBAPI.Card, batch?: boolean): void;
  updateCard(card: MBAPI.Card, batch?: boolean): void;
  removeCard(cardId: string, batch?: boolean): void;
}

export interface StateContext {
  state: State;
  getState(query: CardPaginationQuery): CardPaginationQueryStateWithCards | undefined;
  getCard(id: string): MBAPI.Card;
}

export const [useCardPaginationState, CardPaginationStateContextProvider] =
  createCtx<StateContext>();

export const [useCardPaginationActions, CardPaginationActionsContextProvider] =
  createCtx<ActionsContext>();
